import { createTheme as createMuiTheme, type Theme } from '@mui/material/styles';

import { components } from './components';
import { darkPalette, lightPalette } from './palette';
import { darkCustomShadows, darkShadows, lightCustomShadows, lightShadows } from './shadows';
import { themeConfig } from './theme-config';
import { typography } from './typography';

/**
 * Dois esquemas, um tema. As cores viram variáveis CSS trocadas pelo atributo
 * `data-color-scheme` no `<html>` — é o que permite mudar de claro para escuro sem
 * recriar o tema e sem piscar (o `index.html` aplica o atributo antes do primeiro paint).
 */
export function createTheme(): Theme {
  return createMuiTheme({
    cssVariables: {
      cssVarPrefix: themeConfig.classesPrefix,
      colorSchemeSelector: 'data-color-scheme',
    },
    colorSchemes: {
      light: {
        palette: lightPalette,
        shadows: lightShadows,
        customShadows: lightCustomShadows,
      },
      dark: {
        palette: darkPalette,
        shadows: darkShadows,
        customShadows: darkCustomShadows,
      },
    },
    defaultColorScheme: 'light',
    shadows: lightShadows,
    components,
    typography,
    shape: { borderRadius: 8 },
    // Anel de foco consistente no teclado: quem navega sem mouse precisa ver onde está.
    focusVisible: true,
  });
}
